<template>
    <div class="mb-[28px] pt-[17px] pb-3 lg:mb-[68px]">
        <div class="normal-container flex items-center justify-between">
            <div>
                <ShopwareBreadcrumbs :breadcrumbPrefixEnabled="false" />
            </div>

            <button @click="logoutEvent" class="btn btn-underline inline p-0 font-medium lg:hidden">
                {{ snippets['headless.account.logout'] }}
            </button>
        </div>
        <div>
            <h1 class="py-10 text-center text-2xl leading-[33px] lg:pt-[18px] lg:pb-9 lg:text-[48px] lg:leading-[67px]">
                Welkom, <template v-if="user">{{ user?.firstName }}</template>
            </h1>
            <div class="w-full overflow-x-auto" id="account-navigation">
                <div class="flex w-fit min-w-[525px] justify-center gap-8 px-5 md:w-full lg:px-0" id="acc-nav">
                    <NuxtLink
                        activeClass="!border-green-600 !text-black"
                        to="/account"
                        @click="scrollToLink($event.target)">
                        Overzicht
                    </NuxtLink>
                    <NuxtLink
                        activeClass="!border-green-600 !text-black"
                        to="/account/profile"
                        @click="scrollToLink($event.target)">
                        Mijn profiel
                    </NuxtLink>
                    <NuxtLink
                        activeClass="!border-green-600 !text-black"
                        to="/account/orders"
                        @click="scrollToLink($event.target)">
                        Mijn aankopen
                    </NuxtLink>
                    <NuxtLink
                        activeClass="!border-green-600 !text-black"
                        to="/account/member"
                        @click="scrollToLink($event.target)">
                        Member
                    </NuxtLink>
                    <!--            <NuxtLink activeClass="!border-green-600 text-black" class="border-b-2 border-transparent pb-1 duration-300 hover:text-black text-blg-gray-200" to="/">-->
                    <!--              Spaarpunten & Coupons-->
                    <!--            </NuxtLink>-->
                    <button @click="logoutEvent" class="hidden lg:inline">
                        {{ snippets['headless.account.logout'] }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    const { logout, destroyUserCookies } = useUserExtended();
    const { snippets } = useSnippetsStore();
    const user = inject('user');

    const { getAccountNavigationLinks, scrollToLink } = useAccountNavigation();

    onMounted(() => {
        const links: NodeListOf<HTMLAnchorElement> = getAccountNavigationLinks();
        links?.forEach(link => {
            if (link?.href === window.location.href) {
                scrollToLink(link, 'instant');
            }
        });
    });

    async function logoutEvent() {
        await logout();
        destroyUserCookies();
        window.location.href = '/login';
    }

    const path = ref([
        { name: 'Home', url: '/' },
        { name: 'Mijn account', url: '/account' },
    ]);
</script>
<style scoped>
    @reference "tailwindcss";
    #account-navigation a,
    #account-navigation button {
        @apply !w-max shrink-0 border-b-2 border-transparent pb-1 text-sm duration-300 hover:text-black lg:text-xl;
        font-family: var(--font-monument-extended);
        color: var(--color-blg-gray-200);
    }

    #account-navigation {
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */
    }

    #account-navigation::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
    }
</style>
